import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { VimeoGallery } from './VimeoGallery';

const { appAlias: alias, appName: name } = meta;

export default createApp({ alias, name }, VimeoGallery);
